const productFormati = () => {
    const imgItems = document.querySelectorAll('.single-product-formati-img-item');
    const rows = document.querySelectorAll('.nettuno-formati-table tbody tr.formati-tr');

    if (!rows.length) return;

    // Desktop: image switching on row hover/click
    if (imgItems.length) {
        const activateImage = (targetId) => {
            imgItems.forEach(item => item.classList.remove('active'));
            rows.forEach(r => r.classList.remove('active'));

            const target = document.getElementById(targetId);
            if (target) target.classList.add('active');

            const activeRow = document.querySelector(`.nettuno-formati-table tbody tr[data-target="${targetId}"]`);
            if (activeRow) activeRow.classList.add('active');
        };

        rows.forEach(row => {
            row.addEventListener('mouseenter', function () {
                if (window.innerWidth >= 992) activateImage(this.dataset.target);
            });
            row.addEventListener('click', function () {
                if (window.innerWidth >= 992) activateImage(this.dataset.target);
            });
        });
    }

    // Mobile: Swiper formati
    const formatiSwiperEl = document.querySelector('.formati-swiper');
    if (formatiSwiperEl && window.Swiper) {
        new window.Swiper('.formati-swiper', {
            slidesPerView: 1,
            centeredSlides: true,
            pagination: {
                el: '.formati-swiper .swiper-pagination',
                clickable: true,
            },
        });
    }

    // Slider prodotti compatibili / stessa categoria: 1 mobile, 3 desktop
    const compatibiliEl = document.querySelector('.compatibili-swiper');
    if (compatibiliEl && window.Swiper) {
        new window.Swiper('.compatibili-swiper', {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                prevEl: '.compatibili-btn-prev',
                nextEl: '.compatibili-btn-next',
            },
            pagination: {
                el: '.compatibili-pagination',
                type: 'fraction',
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
        });
    }
};

export default productFormati;
